import axios from 'axios';

export const getIP = async () => {
    return await axios.get(`https://api.ipify.org`
    ).catch((error) => {
        console.log(error);
        return false;
    });
}